export enum RadiusUnitEnum {
  KM = 'KM',
  MI = 'MI',
}
